export const unsupportedIbanCountries = ['MD', 'UA', 'AE', 'BY']
